<script lang="ts">
    import type {Document} from 'typings/portaro.be.types';
    import type {Thread} from 'src/features/threads/types';
    import {getInjector} from 'core/svelte-context/context';
    import {ThreadsService} from 'src/features/threads/services/threads.service';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import ThreadContent from 'src/features/threads/thread-content/ThreadContent.svelte';
    import KpLoadableContainer from 'shared/layouts/KpLoadableContainer.svelte';

    export let record: Document;

    const threadService = getInjector().getByClass(ThreadsService);

    let thread: Thread;
    let loading = true;
    let loadError = false;

    onMount(async () => {
        let loadedThread = await threadService.getThreadByRecord(record);

        if (!exists(loadedThread)) {
            loadedThread = await threadService.createRecordThread(record);
            loading = false;
            return;
        }

        if (!exists(loadedThread)) {
            loading = false;
            loadError = true;
            return;
        }

        thread = loadedThread;
        loading = false;
    });
</script>

<KpLoadableContainer fillSize {loading} {loadError}>
    <ThreadContent {thread} placement="fullscreen-page"/>
</KpLoadableContainer>